import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { ColDef } from 'ag-grid-community';
import { AppState } from 'src/app/app.state';
import { ExportableColDefWithTitle } from 'src/app/shared/ag-grid-config/store/ag-grid-config/ag-grid-config.reducer';
import { SMEDisciplineConfigViewModel } from 'src/app/shared/models/autogenerated';
import { AdapCellClassRules } from 'src/app/shared/utils/ag-grid-utils';
import { nameof } from 'src/app/shared/utils/nameof';
import { selectAllPeerPoolDisciplines } from '../../store/global-settings.selectors';
import { PeerPoolDisciplinesTableActionsRendererComponent } from '../peer-pool-disciplines-actions-renderer/peer-pool-disciplines-actions-renderer.component';
import { PeerPoolDisciplineGridCellActions } from '../../models/peer-pool-discipline-grid-cell-actions.model';
import { WRONG_USER_OID } from 'src/app/shared/utils/graph-client-utils';

@Component({
  standalone: false,
  selector: 'app-peer-pool-disciplines-table',
  templateUrl: './peer-pool-disciplines-table.component.html',
  styleUrls: ['./peer-pool-disciplines-table.component.scss'],
})
export class PeerPoolDisciplinesTableComponent {
  peerPoolDisciplines$ = this.store.select(selectAllPeerPoolDisciplines);

  @Output() editPeerPoolDiscipline = new EventEmitter<string>();
  @Output() deletePeerPoolDiscipline = new EventEmitter<string>();

  configStoreTableName: string = 'peerPoolDisciplines';
  configStoreRouteIdName: string = 'phaseId';

  components = {};

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    filterParams: {
      newRowsAction: 'keep',
    },
    resizable: true,
    cellClassRules: AdapCellClassRules,
  };

  columnDefs: ExportableColDefWithTitle[] = [
    {
      field: nameof<SMEDisciplineConfigViewModel>('name'),
      headerName: 'discipline',
    },
    {
      field: nameof<SMEDisciplineConfigViewModel>('code'),
      headerName: 'code',
      maxWidth: 120,
    },
    {
      field: nameof<SMEDisciplineConfigViewModel>('description'),
      headerName: 'description',
    },
    {
      field: nameof<SMEDisciplineConfigViewModel>('chapterManagersNames'),
      headerName: 'chapter managers',
      valueGetter: (params) =>
        params.data.chapterManagersNames === WRONG_USER_OID
          ? ''
          : params.data.chapterManagersNames,
    },
    {
      maxWidth: 80,
      sortable: false,
      filter: false,
      resizable: false,
      cellRenderer: PeerPoolDisciplinesTableActionsRendererComponent,
      cellRendererParams: {
        onEditClick: (peerPoolDisciplineId: string) =>
          this.editPeerPoolDiscipline.emit(peerPoolDisciplineId),
        onDeleteClick: (peerPoolDisciplineId: string) =>
          this.deletePeerPoolDiscipline.emit(peerPoolDisciplineId),
      } as PeerPoolDisciplineGridCellActions,
      pinned: 'right',
      ignoreExport: true,
    },
  ];

  constructor(private store: Store<AppState>) {}
}
